import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { ReactNode } from 'react';
import { IconButton } from '@mui/material';
import { ReactComponent as CloseIcon } from 'assets/images/close-dialog.svg';
import { WrapperDialog } from './wrapper';

import styles from './styles.module.scss';
import { PaperProps } from '@mui/material/Paper';
import clsx from 'clsx';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type InputProps = {
  title?: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
  open: boolean;
  setOpen: (open: boolean) => void;
  PaperComponent?: React.JSXElementConstructor<PaperProps<'div'>> | undefined;
  classes?: {
    root?: string;
    dialogTitle?: string;
    dialogCloseButton?: string;
  };
};

export const CustomDialog = ({
  title,
  actions,
  children,
  open = false,
  setOpen,
  PaperComponent = WrapperDialog,
  classes,
}: InputProps) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      scroll={'body'}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      PaperComponent={PaperComponent}
      className={clsx(styles.root, classes?.root)}
    >
      {title && (
        <DialogTitle
          classes={{
            root: clsx(styles.title, classes?.dialogTitle),
          }}
        >
          {title}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            classes={{
              root: clsx(styles.closeButton, classes?.dialogCloseButton),
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      )}
      <DialogContent
        sx={{
          padding: '0',
          overflowY: 'unset',
        }}
      >
        {children}
      </DialogContent>
      {actions && (
        <DialogActions
          classes={{
            root: styles.actions,
          }}
        >
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};
